import styled from "styled-components"
import { devices } from "theme/devices"
import WrapperComponent from "components/Wrapper"

const Wrapper = styled.div``

const StyledWrapper = styled(WrapperComponent)``

const InnerWrapper = styled.div`
  ${devices.tabletL} {
    display: flex;
    justify-content: space-between;
  }
`

export default { Wrapper, StyledWrapper, InnerWrapper }
